import { ControlTest } from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import React, { createContext, ReactNode, useContext, useState } from 'react'

type ControlCheckContextType = {
  controlCheck?: ControlTest
  setControlCheck: React.Dispatch<React.SetStateAction<ControlTest | undefined>>
}

export const useControlCheckContext = (): ControlCheckContextType =>
  useContext(ControlCheckContext)

const ControlCheckContext = createContext<ControlCheckContextType>({
  controlCheck: undefined,
  setControlCheck: () => null,
})

export const ControlCheckProvider = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  const [controlCheck, setControlCheck] = useState<ControlTest>()

  return (
    <ControlCheckContext.Provider
      value={{
        controlCheck,
        setControlCheck,
      }}
    >
      {children}
    </ControlCheckContext.Provider>
  )
}
